/**
 * InfinitSales - Notification Bell (compartilhado)
 *
 * Sino + bolinha de não-lidas + flyout (NotificationPanel) ancorado ABAIXO do
 * botão, à direita. Usado na barra superior do inbox (mobile e desktop) — antes
 * vivia só no rodapé da NavSidebar. Self-contained: consome NotificationsContext.
 */
import React, { useState, useEffect, useRef } from 'react';
import { Bell } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useNotifications } from '../../contexts/NotificationsContext';
import NotificationPanel from './NotificationPanel';

const NotificationBell = ({ size = 20 }) => {
  const { colors } = useTheme();
  const { unreadCount, refresh } = useNotifications();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  return (
    <div ref={containerRef} style={{ position: 'relative', flexShrink: 0 }}>
      <button
        type="button"
        onClick={() => {
          const next = !open;
          setOpen(next);
          if (next) refresh?.();
        }}
        title="Notificações"
        style={{
          width: 40, height: 40,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: 'none', background: 'transparent',
          color: open ? colors.accentPrimary : colors.textSecondary,
          borderRadius: '50%', cursor: 'pointer', position: 'relative',
        }}
      >
        <Bell size={size} />
        {unreadCount > 0 && (
          <span style={{
            position: 'absolute', top: 6, right: 6,
            width: 9, height: 9, borderRadius: '50%',
            backgroundColor: '#ef4444',
            border: `2px solid ${colors.bgPrimary}`,
          }} />
        )}
      </button>
      {open && (
        <NotificationPanel
          onClose={() => setOpen(false)}
          // Dropdown ancorado abaixo do sino, alinhado à direita.
          panelStyle={{ left: 'auto', right: 0, bottom: 'auto', top: 'calc(100% + 8px)' }}
        />
      )}
    </div>
  );
};

export default NotificationBell;
